import React, { useEffect, useState } from 'react';
import { trackPromise } from 'react-promise-tracker';

import InfiniteScroll from 'react-infinite-scroll-component';
import { Dropdown, List, Menu} from 'antd';
import IcNotificacao from '../../../../assets/icons/IconNotificacoes.svg'
import services from '../../../../services'

import './styles.scss';

const ListNotificacoes = ({ notificacoes, showNotificacao }) => {

  const { IdUser, login, IsAdmin } = services.storage.getUser();
  const [notificacaoSelecionada, setNotificacaoSelecionada] = useState("");
  return (
    <div>
      <List
        className='list-permissoes mt-4'
        size='small'
        header={<span className='list-header'>ÚLTIMAS NOTIFICAÇÕES ENVIADAS</span>}
        dataSource={notificacoes}
        renderItem={item => {
          return (
            <List.Item
            className='list-item listaNotificacao'
            style={{cursor:'pointer'}}  onClick={() => { showNotificacao(item.id); setNotificacaoSelecionada(item.id)}}>
              <div
                
                >
                <img src={IcNotificacao}  alt="Ícone" />
              
                <span 
                className='usuario-nomeNotificacao'
                onClick={() => { showNotificacao(item.id); }}> {item.titulo}</span>
              </div>
            </List.Item>
          )
        }}
      />

    </div>
  )
}

export default ListNotificacoes;